import { makeStyles } from '@material-ui/core'
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import Icon from '@mdi/react'
import {
    mdiAlertCircleOutline,
    mdiCheckCircleOutline,
    mdiCloseCircleOutline,
    mdiPower
} from '@mdi/js'
import { CustomLink } from '../../root/components/common/link'

export function PinPopUp({ location, isMobile }) {
    const { theme, locale } = useSelector(state => state.main)
    const classes = useStyles()

    const totalDevices = useMemo(() => {
        return (
            location.devices_active +
            location.devices_critical +
            location.devices_inactive +
            location.devices_warning
        )
    }, [location])

    const DevicesInfo = ({ location }) => {
        return (
            <div className={classes.iconsWrapper}>
                <div className={classes.iconsRow}>
                    <Icon
                        path={mdiCheckCircleOutline}
                        size={1}
                        color={theme.active}
                    />
                    <span
                        style={{
                            color: theme.active,
                            marginLeft: 4
                        }}
                    >
                        {location.devices_active}
                    </span>
                </div>
                <div className={classes.iconsRow}>
                    <Icon
                        path={mdiCloseCircleOutline}
                        size={1}
                        color={theme.error}
                    />
                    <span
                        style={{
                            color: theme.error,
                            marginLeft: 4
                        }}
                    >
                        {location.devices_critical}
                    </span>
                </div>
                <div className={classes.iconsRow}>
                    <Icon
                        path={mdiAlertCircleOutline}
                        size={1}
                        color={theme.warning}
                    />
                    <span
                        style={{
                            color: theme.warning,
                            marginLeft: 4
                        }}
                    >
                        {location.devices_warning}
                    </span>
                </div>
                <div className={classes.iconsRow}>
                    <Icon path={mdiPower} size={1} color={theme.secondary} />
                    <span
                        style={{
                            color: theme.secondary,
                            marginLeft: 4
                        }}
                    >
                        {location.devices_inactive}
                    </span>
                </div>
            </div>
        )
    }

    const AddressInfo = ({ location, isMobile }) => {
        const onMobilePressLocationDetails = () =>
            window.ReactNativeWebView?.postMessage(
                `showLocationDetails-${location.id}`
            )

        return (
            <div className={classes.addressWrapper}>
                <div className={classes.addressRow}>
                    <CustomLink
                        isMobile={isMobile}
                        onMobilePress={onMobilePressLocationDetails}
                        name={location.name}
                        path={`/locations/${location.id}/overview`}
                    />
                </div>
                <div className={classes.addressRow}>
                    <span className={classes.addressDetails}>
                        {location.address}
                    </span>
                </div>
            </div>
        )
    }

    const LinksInfo = ({ location, isMobile }) => {
        const onMobilePressFloorPlan = () =>
            window.ReactNativeWebView?.postMessage(
                `showFloorplan-${location.id}`
            )

        return (
            <div className={classes.linksWrapper}>
                {location.has_floor_plan ? (
                    <CustomLink
                        isMobile={isMobile}
                        onMobilePress={onMobilePressFloorPlan}
                        name={locale.locations.floorPlan}
                        path={`/locations/${location.id}/floor-plan`}
                    />
                ) : (
                    `${locale.locations.noFloorplan}`
                )}
                {!isMobile ? (
                    <CustomLink
                        name={'Google maps'}
                        path={`http://maps.google.com/maps?q=${location.latitude},${location.longitude}`}
                        isReactRouterLink={false}
                    />
                ) : null}
            </div>
        )
    }

    return (
        <div className={classes.pinPopUpWrapper}>
            <AddressInfo location={location} isMobile={isMobile} />
            <div
                className={classes.label}
            >{`${locale.locations.devices}: ${totalDevices}`}</div>
            <DevicesInfo location={location} />
            <LinksInfo location={location} isMobile={isMobile} />
        </div>
    )
}

const useStyles = makeStyles(theme => ({
    pinPopUpWrapper: {
        display: 'flex',
        flexDirection: 'column',
        gap: '4px'
    },
    label: {
        fontSize: '12px'
    },
    iconsWrapper: {
        marginTop: 8,
        marginBottom: 8,
        display: 'flex'
    },
    iconsRow: {
        display: 'flex',
        alignItems: 'center',
        marginRight: 16
    },
    addressWrapper: {
        display: 'flex',
        flexDirection: 'column',
        gap: '4px'
    },
    addressRow: {
        display: 'flex'
    },
    addressDetails: {
        display: 'flex',
        justifyContent: 'flex-start',
        fontSize: '12px'
    },
    linksWrapper: {
        display: 'flex',
        flexDirection: 'column',
        gap: '3px'
    },
    tooltipClass: {
        backgroundColor: theme.primary,
        opacity: 1
    }
}))
